module.exports = __webpack_public_path__ + "img/team.9a707a2e.png";